<template>
    <div class="zoom standard" :style="css">
        <span :class="['zoom-in', { disabled: inDisabled }]" @click="zoomIn">
            <span class="tip">{{ $t('zoomIn') }}</span>
        </span>
        <span :class="['zoom-out', { disabled: outDisabled }]" @click="zoomOut">
            <span class="tip">{{ $t('zoomOut') }}</span>
        </span>
    </div>
</template>
<script>
export default {
    i18next: {
        ns: 'map'
    },
    props: {
        css: {
            type: [Object, String],
            default: ''
        }
    },
    inject: ['applyMap'],
    data: function() {
        return {
            inDisabled: false,
            outDisabled: false
        };
    },
    mounted() {
        this.applyMap().then(([map, maps, siteMap]) => {
            let zoomChange = () => {
                let zoom = map.getZoom();
                this.outDisabled = zoom <= siteMap.config.minZoom;
                this.inDisabled = zoom >= siteMap.config.maxZoom;
            };
            map.addEventListener('mapviewchangeend', zoomChange);
            zoomChange();
        });
    },
    methods: {
        zoomIn() {
            this.applyMap().then(([map, maps, siteMap]) => {
                let zoom = Math.round(map.getZoom());
                if (zoom < siteMap.config.maxZoom) {
                    map.setZoom(zoom + 1, siteMap.opt_animate);
                    this.$EventBus.$emit('siteTrack', {
                        action: 'zoom-in',
                        label: zoom + 1,
                        trackType: 'map-event',
                        ele: this.$el
                    });
                }
            });
        },
        zoomOut() {
            this.applyMap().then(([map, maps, siteMap]) => {
                let zoom = Math.round(map.getZoom());
                if (zoom > siteMap.config.minZoom) {
                    map.setZoom(zoom - 1, siteMap.opt_animate);
                    this.$EventBus.$emit('siteTrack', {
                        action: 'zoom-out',
                        label: zoom - 1,
                        trackType: 'map-event',
                        ele: this.$el
                    });
                }
            });
        }
    }
};
</script>
<style lang="scss">
.zoom.standard {
    width: 30px;
    height: 60px;
    .zoom-out,
    .zoom-in {
        display: block;
        width: 100%;
        height: 50%;
        position: relative;
        background: #fff;
        border-radius: 2px;
        &:after {
            position: absolute;
            background-color: #191919;
            content: '';
            width: 14px;
            height: 2px;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        &:hover .tip {
            display: block;
        }
    }
    .zoom-in {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        &:before {
            position: absolute;
            background-color: #191919;
            content: '';
            width: 2px;
            height: 14px;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        &.disabled:after,
        &.disabled:before {
            opacity: 0.4;
        }
    }
    .zoom-out {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        &:before {
            position: absolute;
            content: '';
            left: 50%;
            top: 0;
            width: 30px;
            height: 1px;
            background-image: linear-gradient(
                to left,
                #ffffff,
                #dadce2,
                #ffffff
            );
            transform: translateX(-50%);
        }
        &.disabled:after {
            opacity: 0.4;
        }
    }
}
</style>
